import React, { Fragment } from 'react';


/**
 * props:
 * 	- count:  how many spaces to display
*/
export function Spaces(props) {
	var jsx = "";
	for (var i = 0; i < props.count; i++) {
		jsx = <Fragment>&nbsp;{jsx}</Fragment>;
	}
	return jsx;
}
